module.exports = __webpack_public_path__ + "officialStatic/img/p2.b55e448.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/p2.png
// module id = XJDE
// module chunks = 0